import { CodeSection } from './code-subject-section';

export const CodeSectionEventoRiconoscimento = [
  CodeSection.DATI_GENERALI_CONS_ASS_RICO,
  CodeSection.DATI_GENERALI_ASS_RICO,
  CodeSection.DATI_GENERALI_PRES_DOC,
  CodeSection.DATI_GENERALI_PRES_DOC_EVENTO,
  CodeSection.DATI_GENERALI_RICO_GEN,
  CodeSection.DATI_GENERALI_CONS_RICO,
  CodeSection.DATI_GENERALI_CONSENSO,
  CodeSection.DATI_GENERALI_CONS_RICO_EVENTO,
  CodeSection.DATI_GENERALI_CONS_ASS_COGNRID_RICO,
  CodeSection.DATI_GENERALI_CONS_RICO_SENT,
  CodeSection.DATI_GENERALI_ASS_RICO_P,
];
